import React, { useRef } from "react";
import { Container } from "reactstrap";
import "./header.css";
import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../apiCalls/userApiCalls";

// const commonStyles={
//   fontWeight: 500,
//       fontSize: "1.1rem",
//       color: "#0a2b1e",
//       textDecoration: "none",
//       transition: "0.3s",
//       border:"none",
//       textTransform:"none"
// }

const navLinks = [
  // {
  //   display: "Home",
  //   url: "#",
  //   style:commonStyles
  // },
  // {
  //   display: "About",
  //   url: "#",
  //   style:commonStyles
  // },
  {
    display: "Register",
    url: `/signUp`,
    style: { color: "#17bf9e", borderColor: "#17bf9e" },
  },

  {
    display: "Sign In",
    url: `/signIn`,
    style: { color: "#17bf9e", borderColor: "#17bf9e" },
  },

  // {
  //   display: "Courses",
  //   url: "#",
  // },
  // {
  //   display: "Courses",
  //   url: "#",
  // },
];

const afterSignInNavLinks = [
  {
    display: "Profile",
    url: "/profile",
  },
];
const Header = () => {
  const menuRef = useRef();
  let navigate = useNavigate();
  const user = sessionStorage.getItem("user");
  const menuToggle = () => menuRef.current.classList.toggle("active__menu");

  return (
    <header className="header">
      <Container>
        <div className="navigation d-flex align-items-center justify-content-between">
          <div className="logo">
            <h2 className=" d-flex align-items-center gap-1">
              <Box
                component="img"
                sx={{
                  width: "120px",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  marginTop: "8px",
                  cursor: "pointer",
                }}
                src="https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2FS2A%20(1).png?alt=media&token=7361b0dc-d989-47fa-92a1-9ea0db08d3fc"
                alt="random"
                onClick={() => navigate("/")}
              ></Box>{" "}
              Academy
            </h2>
          </div>

          <div className="nav d-flex align-items-center gap-5">
            <div className="nav__menu" ref={menuRef} onClick={menuToggle}>
              <ul className="nav__list">
                {!user ? (
                  navLinks.map((item, index) => (
                    <li key={index} className="nav__item">
                      <Button
                        variant="outlined"
                        style={item.style}
                        onClick={() => {
                          navigate(`${item.url}`);
                        }}
                      >
                        {item.display}
                      </Button>
                    </li>
                  ))
                ) : (
                  <>
                    {afterSignInNavLinks.map((item, index) => (
                      <li key={index} className="nav__item">
                        <Button
                          variant="text"
                          style={item.style}
                          onClick={() => {
                            navigate(`${item.url}`);
                          }}
                        >
                          {item.display}
                        </Button>
                      </li>
                    ))}
                    <li className="nav__item">
                      <Button
                        variant="text"
                        onClick={() => {
                          logout();
                          navigate("/");
                        }}
                      >
                        Logout
                      </Button>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>

          <div className="mobile__menu">
            <span>
              <i class="ri-menu-line" onClick={menuToggle}></i>
            </span>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
